// Module
var code = "<a class=\"pointer-cursor\"> <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span> <div> <span>Balance: {{ match.model.availableBalance | currency }}</span> </div> </a> ";
// Exports
module.exports = code;